import { createFileRoute } from '@tanstack/react-router'
import SettingsLinkedIn from '@/features/settings/linkedin'

export const Route = createFileRoute('/_authenticated/settings/linkedin')({
  component: SettingsLinkedIn,
})
